module.exports = __webpack_public_path__ + "static/media/video-case-3dcommerce.ac20a324.mp4";